module.exports = __webpack_public_path__ + "static/media/packshot-angle.a9822b94.png";